import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.0834 2.91602H3.91675C3.36446 2.91602 2.91675 3.36373 2.91675 3.91601V5.87943C2.91675 6.11814 3.00214 6.34897 3.15749 6.53022L7.676 11.8018C7.83136 11.9831 7.91675 12.2139 7.91675 12.4526V16.8556C7.91675 17.5631 8.63127 18.0469 9.28814 17.7841L11.4548 16.9175C11.8345 16.7656 12.0834 16.3979 12.0834 15.989V12.4526C12.0834 12.2139 12.1688 11.9831 12.3242 11.8018L16.8427 6.53022C16.998 6.34897 17.0834 6.11814 17.0834 5.87943V3.91602C17.0834 3.36373 16.6357 2.91602 16.0834 2.91602Z",
      stroke: "currentColor",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }